import { Component, inject, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'tt-draw-disclaimer-dialog',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule
  ],
  templateUrl: './draw-disclaimer-dialog.component.html',
  // styleUrls: ['./draw-disclaimer-dialog.component.css'],
  standalone: true
})
export class DrawDisclaimerDialogComponent {
  public data = inject<any>(MAT_DIALOG_DATA);
  constructor(public dialogRef: MatDialogRef<DrawDisclaimerDialogComponent>,

  ) { }
}
